import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';

import AuthContext from 'app/src/contexts/AuthContext';
import { SubNavContainer, LinkContainer, LinkSpace } from 'app/src/elements';
import Modal from 'app/src/elements/Modal';
import { Link } from 'app/src/utils/routing';

import NewPayment from './new';

const SubNav = ({ refetch }) => {
  const { hasPolicy } = useContext(AuthContext);
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <SubNavContainer>
      <LinkContainer>
        {hasPolicy({ type: 'Txn', action: 'create' }) && (
          <>
            <Pressable onPress={() => setShowAddModal(true)} >
              <Text>+ Receive Payment</Text>
            </Pressable>
            <LinkSpace />

            <Link to="/accounting/invoices">
              <Text>Invoices</Text>
            </Link>
            <LinkSpace />
          </>
        )}
      </LinkContainer>

      {showAddModal &&
        <Modal
          showModal
          setShowModal={setShowAddModal}
          modalType="Receive Payment"
        >
          <NewPayment
            setShowModal={setShowAddModal}
            refetch={refetch}
          />
        </Modal>
      }
    </SubNavContainer>
  );
};

export default SubNav;
